import { render, staticRenderFns } from "./menu-single.vue?vue&type=template&id=d070c6ae&scoped=true&lang=pug"
import script from "./menu-single.vue?vue&type=script&lang=coffee"
export * from "./menu-single.vue?vue&type=script&lang=coffee"
import style0 from "./menu-single.vue?vue&type=style&index=0&id=d070c6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d070c6ae",
  null
  
)

export default component.exports